<template>
  <div class="page">
    <div class="m-bg-cover"></div>
    <div class="m-top-margin"></div>
    <p v-if="appHomeVO.userRegisterStatus==-1" class="m-status">未报名</p>
    <p v-if="appHomeVO.userRegisterStatus==0" class="m-status">报名未缴费</p>
    <p v-if="appHomeVO.userRegisterStatus==1&&register.hasOfflinePay!=1" class="m-status">报名成功</p>
    <p v-if="appHomeVO.userRegisterStatus==1&&register.hasOfflinePay==1" class="m-status">报名成功</p>
    <p v-if="appHomeVO.userRegisterStatus==4&&register.hasOfflinePay==1" class="m-status">已报名</p>
    <p v-if="appHomeVO.userRegisterStatus==5&&register.hasOfflinePay==1" class="m-status">报名不通过</p>
    <p class="m-tit">{{appHomeVO.name}}</p>
    <!--是否审核-->
    <div v-if="register.hasExamine==1" class="m-big-rel">
      <div class="m-real">
        <span>审核状态</span>
        <span v-if="appHomeVO.examineStatus==1" style="color: #2B6CF9">审核通过</span>
        <span v-else-if="appHomeVO.examineStatus==2" else="" style="color: #F13C3A">审核不通过</span>
        <span v-else="" style="color: #F19E3B">未审核</span>
      </div>
      <div v-if="appHomeVO.examineComment&&(appHomeVO.examineStatus==1||appHomeVO.examineStatus==2)" class="m-black">
        <p>{{appHomeVO.examineComment}}</p>
      </div>
      <div v-if="appHomeVO.examineComment&&(appHomeVO.examineStatus==1||appHomeVO.examineStatus==2)" class="m-kou"></div>
    </div>
    <!--人脸识别-->
    <div v-if="register.hasFaceRecognize==1&&register.realAuthentication==1" class="m-real">
      <span>人脸识别</span>
      <span v-if="appHomeVO.hasNameAccess==1" style="color: #2B6CF9">已通过</span>
      <span v-else="" style="color: #F19E3B">未识别</span>
    </div>
    <!--支付信息-->
    <div v-if="appHomeVO.hasPayment==1" class="m-info-box">
      <div class="m-info-tit"><img src="@/assets/img/home/payIco.png" alt=""><span>支付信息</span>
        <div class="m-info-pay">
          <div v-if="appHomeVO.payStatus==1">
            <em class="m-app-btn" v-if="register.hasApplyRefund==1&&examineStatus!=2" @click="goRefund(appHomeVO.payStatus,register.hasApplyRefund)">申请退款</em>
            <van-tag v-if="register.hasApplyRefund==1&&examineStatus==2" color="#ffe8e8" size="medium" text-color="#F13C3A" @click="goRefund(4,register.hasApplyRefund)">退款失败</van-tag>
            <van-tag v-else="" v-if="register.hasApplyRefund!=1" color="#7a9ce3" size="medium" text-color="#fff">已支付</van-tag>
          </div>
          <div @click="goRefund(appHomeVO.payStatus,register.hasApplyRefund)" v-if="appHomeVO.payStatus!=1">
            <van-tag v-if="appHomeVO.payStatus==0" color="#ffe8e8" size="medium" text-color="#fd2330">未缴费</van-tag>
            <van-tag v-if="appHomeVO.payStatus==5" color="#ffe8e8" size="medium" text-color="#fd2330">缴费处理中</van-tag>
            <van-tag v-if="appHomeVO.payStatus==2" color="#FFF5EA" size="medium" text-color="#F19E3B">退款中</van-tag>
            <van-tag v-if="appHomeVO.payStatus==3" color="#F2F6FF" size="medium" text-color="#2B6CF9">退款成功</van-tag>
            <van-tag v-if="appHomeVO.payStatus==4" color="#ffe8e8" size="medium" text-color="#F13C3A">退款失败</van-tag>
          </div>
          <van-icon @click="goRefund(appHomeVO.payStatus,register.hasApplyRefund)" v-if="register.hasApplyRefund==1&&appHomeVO.payStatus!=0" class="m-right" name="arrow"/>
        </div>
      </div>
      <div v-if="payRecordPO&&payRecordPO.outOrderNo" class="m-nav"><span>订单编号</span><p>{{payRecordPO.outOrderNo}}</p></div>
      <div v-if="payRecordPO&&payRecordPO.paymentWayName" class="m-nav"><span>支付方式</span><p>{{payRecordPO.paymentWayName}}</p></div>
      <div v-if="payRecordPO&&payRecordPO.amount" class="m-nav"><span>支付金额</span><p>{{payRecordPO.amount ? payRecordPO.amount/100 :''}}元</p></div>
      <div v-if="payRecordPO&&payRecordPO.payedTime" class="m-nav"><span>支付时间</span><p>{{payRecordPO.payedTime}}</p></div>
    </div>
    <!--个人信息-->
    <div v-if="verifyUserInfo==1" class="m-info-box">
      <div class="m-info-tit"><img src="@/assets/img/home/bcInfo.png" alt=""><span>个人信息</span></div>
      <div v-if="indicate('realName')" class="m-nav"><span>姓名</span><p>{{userInfoVO.realName}}</p></div>
      <div v-if="indicate('idCardNum')" class="m-nav"><span>证件号码</span><p>{{userInfoVO.idCardNum}}</p></div>
      <div v-if="indicate('phone')" class="m-nav"><span>手机号码</span><p>{{userInfoVO.phone}}</p></div>
      <div v-if="indicate('examinationNumb')" class="m-nav"><span>考籍号</span><p>{{userInfoVO.examinationNumb}}</p></div>
      <div v-if="indicate('userType')" class="m-nav"><span>考生类型</span><p>{{userInfoVO.userType}}</p></div>
      <div v-if="indicate('userMajor')" class="m-nav"><span>考生专业</span><p>{{userInfoVO.userMajor}}</p></div>
      <div v-if="indicate('userSubName')" class="m-nav"><span>考生学科</span><p>{{userInfoVO.userSubName}}</p></div>
    </div>
    <!--报考信息-->
    <div v-if="relevanceExam==1" class="m-info-box">
      <div class="m-bast">
        <div><img src="@/assets/img/home/myInfo.png" alt=""><span>报考信息</span></div>
        <van-button @click="goTo(appHomeVO,'/examInfo',2)" class="m-btn" v-if="appHomeVO.examineStatus!=1&&appHomeVO.userRegisterStatus!=2&&appHomeVO.userRegisterStatus!=1&&appHomeVO.status!=2&&appHomeVO.hasPayment==1" round >修改</van-button>
        <!--无需缴费的报名-->
        <van-button @click="goTo(appHomeVO,'/examInfo',2)" class="m-btn" v-if="appHomeVO.examineStatus!=1&&appHomeVO.userRegisterStatus!=2&&appHomeVO.status!=2&&appHomeVO.hasPayment!=1&&!(appHomeVO.hasArrange)&&register.hasOfflinePay!=1" round >修改</van-button>
        <!--长沙理工大学-->
        <van-button @click="goTo(appHomeVO,'/examInfo',2)" class="m-btn" v-if="appHomeVO.examineStatus!=1&&appHomeVO.userRegisterStatus!=2&&appHomeVO.userRegisterStatus!=1&&appHomeVO.userRegisterStatus!=5&&appHomeVO.status!=2&&register.hasOfflinePay==1&&!(appHomeVO.hasArrange)&&appHomeVO.hasPayment!=1" round >修改</van-button>
      </div>
      <div class="m-nav"><span>考试</span><p>{{examName}}</p></div>
      <div v-if="register.subjectRequired==1" class="m-nav"><span>考试科目</span><p>{{subNames}}</p></div>
      <div v-if="register.regionsRequired==1" class="m-nav"><span>考区</span><p>{{appHomeVO.useExamRegionsName}}</p></div>
      <div v-if="register.siteRequired==1" class="m-nav"><span>考点</span><p>{{examSiteName}}</p></div>
      <div v-if="register.hasGraduation==1" class="m-nav"><span>在籍状态</span><p v-if="hasNative ==1">在籍</p><p v-if="hasNative+'' ==='0'">已毕业</p></div>
      <div v-if="register.hasGraduation==1&&hasNative+''==='0'" class="m-nav"><span>毕业时间</span><p>{{graduationTime ? dayjs(graduationTime).format('YYYY-MM') : ''}}</p></div>
      <div v-if="register.hasGraduation==1&&hasNative+''==='0'&&register.hasTheoryGrade==1" class="m-nav"><span>论文成绩</span><p>{{theoryGrade}}</p></div>
      <div v-if="register.userAddress==1" class="m-nav"><span>考生地址</span><p>{{userAddress}}</p></div>
      <div v-for="(item,index) in fieldArray" :key="index" class="m-nav">
        <span>{{item.showName}}</span>
        <p v-if="item.type=='text'||item.type=='date'||item.type=='drop'">{{item.showValue}}</p>
        <div class="m-pic" v-if="item.type=='file'"><img v-if="item.showValue" :src="item.showValue" alt=""></div>
      </div>
    </div>
    <!--低部按钮-->
    <div class="m-footer" v-if="appHomeVO.userRegisterStatus!=1&&appHomeVO.status!=2&&register.hasOfflinePay!=1">
      <span v-if="appHomeVO.examineStatus!=1" @click="noCal(appHomeVO)">取消报名</span>
      <div class="m-btn-box">
        <van-button v-if="appHomeVO.hasNameAccess!=1&&register.realAuthentication==1&&register.hasFaceRecognize==1" block @click="goTo(appHomeVO,'face')" class="m-btn m-btn1">人脸识别</van-button>
        <van-button v-if="appHomeVO.userRegisterStatus==0&&appHomeVO.payStatus!=5" block @click="goTo(appHomeVO,'/examPay',3)" class="m-btn m-btn2">去支付</van-button>
      </div>
      <div class="m-des" v-if="register.hasExamine==1&&appHomeVO.examineStatus==2">
        <van-icon class="warning-o" name="warning-o" />
        <span>建议修改报考信息重新提交审核</span>
      </div>
    </div>
    <!--报名成功无需支付-->
    <div class="m-footer" v-if="appHomeVO.status!=2&&appHomeVO.userRegisterStatus==1&&appHomeVO.hasPayment!=1">
      <div class="m-left-footer">
        <van-button v-if="appHomeVO.hasNameAccess!=1&&register.realAuthentication==1&&register.hasFaceRecognize==1" block @click="goTo(appHomeVO,'face')" class="m-btn m-btn1">人脸识别</van-button>
      </div>
      <!--<span v-if="!(appHomeVO.hasArrange)&&register.hasOfflinePay!=1&&appHomeVO.examineStatus!=1" @click="noCal(appHomeVO)">取消报名</span>-->
      <div class="m-btn-box">
        <van-button v-if="appHomeVO.hasAccessAdmission==1" block @click="goNote(appHomeVO)" class="m-btn m-btn3">准考证打印</van-button>
        <van-button style="margin-left: 10px" v-if="appHomeVO.hasShowScore==1" block @click="goAchieve(appHomeVO)" class="m-btn m-btn3">成绩查询</van-button>
      </div>
    </div>
    <!--报名成功需支付-->
    <div class="m-footer" v-if="appHomeVO.status!=2&&appHomeVO.userRegisterStatus==1&&appHomeVO.hasPayment==1">
      <div class="m-left-footer">
        <van-button v-if="appHomeVO.hasNameAccess!=1&&register.realAuthentication==1&&register.hasFaceRecognize==1" block @click="goTo(appHomeVO,'face')" class="m-btn m-btn1">人脸识别</van-button>
      </div>
      <div class="m-btn-box">
        <van-button v-if="appHomeVO.hasAccessAdmission==1" block @click="goNote(appHomeVO)" class="m-btn m-btn3">准考证打印</van-button>
        <van-button style="margin-left: 10px" v-if="appHomeVO.hasShowScore==1" block @click="goAchieve(appHomeVO)" class="m-btn m-btn3">成绩查询</van-button>
      </div>
    </div>
    <!--长沙理工大学未报名-->
    <div class="m-footer" v-if="appHomeVO.status!=2&&appHomeVO.userRegisterStatus==-1&&register.hasOfflinePay==1">
      <span v-if="false" @click="noCal(appHomeVO)">取消报名</span>
      <div class="m-btn-box">
        <van-button v-if="appHomeVO.hasNameAccess!=1&&register.realAuthentication==1&&register.hasFaceRecognize==1" block @click="goTo(appHomeVO,'face')" class="m-btn m-btn1">人脸识别</van-button>
      </div>
    </div>
    <!--报名结束-->
    <div class="m-footer" v-if="appHomeVO.status==2">
      <div class="m-left-footer"></div>
      <div class="m-btn-box">
        <van-button v-if="appHomeVO.userRegisterStatus==0&&appHomeVO.hasPayment==1&&appHomeVO.payStatus!=5" block @click="goTo(appHomeVO,'/examPay',3)" class="m-btn m-btn2">去支付</van-button>
        <van-button v-if="appHomeVO.hasAccessAdmission==1&&appHomeVO.userRegisterStatus==1" block @click="goNote(appHomeVO)" class="m-btn m-btn3">准考证打印</van-button>
        <van-button style="margin-left: 10px" v-if="appHomeVO.hasShowScore==1&&appHomeVO.userRegisterStatus==1" block @click="goAchieve(appHomeVO)" class="m-btn m-btn3">成绩查询</van-button>
      </div>
    </div>
    <!--弹出退出确认框-->
    <van-popup v-model="show" round get-container="body">
      <div class="m-popup">
        <div class="m-title">是否下载准考证</div>
        <div class="m-chose">
          <p @click="show=false">取消</p>
          <p @click="getDown()">
            确定
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { mapGetters,mapMutations } from 'vuex'
  import {nationArr} from "@/utils/nation"
  import { Dialog } from 'vant';
  export default {
    components: {
      [Dialog.Component.name]: Dialog.Component,
    },
    computed: {
      ...mapGetters({
        CONFIG_ITEM: 'enroll/configItem',
        USER_INFO: 'user/userInfo'
      })
    },
    data () {
      return {
        appHomeVO: {},
        userInfoVO:{},
        examName:'',
        subNames:'',
        examSiteName:'',
        userAddress:'',
        verifyUserInfo:'',
        relevanceExam:'',
        graduationTime:'',
        theoryGrade:'',
        hasNative:'',
        userShowList:[],
        register:{},
        payRecordPO:{},
        formDataArray:[
          {nameKey:'username',showValue:'',showName:'姓名', type:'text', required:true, multiple:false, templateList:[] },
          {nameKey:'sex',showValue:'',showName:'性别', type:'drop', required:true, multiple:false, templateList:[] },
          {nameKey:'idCardNumb',showValue:'',showName:'身份证号', type:'text', required:true, multiple:false, templateList:[] },
          {nameKey:'birthDay',showValue:'',showName:'出生日期', type:'date', required:true, multiple:false, templateList:[] },
          {nameKey:'nation',showValue:'',showName:'民族', type:'drop', required:true, multiple:false, templateList:[] },
          {nameKey:'position',showValue:'',showName:'职级', type:'drop', required:true, multiple:false, templateList:[] },
          {nameKey:'maxEdu',showValue:'',showName:'最高学历', type:'drop', required:true, multiple:false, templateList:[] },
          {nameKey:'eduMajor',showValue:'',showName:'学历专业', type:'text', required:true, multiple:true, templateList:[] },
          {nameKey:'personnelNature',showValue:'',showName:'人员性质', type:'drop', required:true, multiple:false, templateList:[] },
          {nameKey:'hasLawSeniority',showValue:'',showName:'是否具有法律职业资格证书', type:'drop', required:true, multiple:false, templateList:[] },
          {nameKey:'politicalOutlook',showValue:'',showName:'政治面貌', type:'drop', required:true, multiple:false, templateList:[] },
          {nameKey:'idCardPhoto',showValue:'',showName:'证件照', type:'file', required:true, multiple:false, templateList:[] },
        ],
        fieldArray:[],
        userInfoExtPO:{},
        show: false,
        title:'',
        hrefUrl:'',
        setId:'',
        token:window.localStorage.getItem('token'),
        examineStatus:'',
      }
    },
    created () {
      this.getIdInfo()
    },
    methods: {
      ...mapMutations({
        SET_ENROLL_KEY: 'enroll/setEnrollKey'
      }),
      goTo(i, y,z){
        if(i.payStatus==5){
          this.utils.toastNone('缴费处理中不允许修改信息！')
          return
        }
        if(i.status==2){
          this.utils.toastNone('报名已经结束！')
          return
        }
        if(z>1&&this.register.hasFaceRecognize==1&&i.hasNameAccess!=1){
          this.utils.toastNone('请先完成人脸识别！')
          return
        }
        if(z==3){
          this.http.getRequest({
            url:`app/exam/findExamInfoSubmit/${i.id}`,
            msg:{},
            success:(res)=>{
              if(res.data+''=='true'){
                this.SET_ENROLL_KEY({key: 'configItem', value: i})
                this.$router.push({
                  path: y,
                  query:{
                    id:i.id
                  }
                })
              }else {
                this.utils.toastNone('请完善报考信息！')
              }
            }
          })
        }else {
          this.SET_ENROLL_KEY({key: 'configItem', value: i})
          if(y==='face'){
            if(this.USER_INFO.hasNameAccess!=1){
              this.utils.toastNone('此账号为未实名或已过期的状态，请去个人中心实名认证！')
              return
            }
            this.$router.push({
              path:this.register.recognizeType==1 ? '/livingFace' : '/face',
              query:{
                id:i.id
              }
            })
          }else {
            this.$router.push({
              path: y,
              query:{
                id:i.id
              }
            })
          }
        }
      },
      goNote(i){
        if(this.register.realAuthentication==1){
          if(this.USER_INFO.hasNameAccess!=1){
            this.utils.toastNone('此账号为未实名或已过期的状态，请去个人中心实名认证！')
            return
          }
        }
        if(this.register&&this.register.hasReadAdmissionNotice==1){
          this.$router.push({
            path:'/notes',
            query:{
              admissionNoticeId:this.register.admissionNoticeId,
              examId:i.id
            }
          })
        } else {
          this.getBol(i.id)
        }
      },
      getBol(id){
        this.show = true
        this.setId = id
      },
      getDown(){
        window.open(`/api/app/exam/downLoadAdmission/${this.setId}?token=${this.token}`)
        this.show = false
      },
      //详情
      getMore(){
        this.http.getRequest({
          url:`app/exam/findUserRegisterInfo/${this.$route.query.detailId}`,
          msg:{},
          success:(res)=>{
            this.appHomeVO = res.data.appHomeVO
            this.userInfoVO = res.data.userInfoVO
            this.examName = res.data.examName
            this.subNames = res.data.subNames
            this.examSiteName = res.data.examSiteName
            this.userAddress = res.data.userAddress
            this.payRecordPO = res.data.payRecordPO ? res.data.payRecordPO : {}
            this.SET_ENROLL_KEY({key: 'configItem', value: res.data&&res.data.appHomeVO ? res.data.appHomeVO :{}})
            this.getSetCofig()
          }
        })
      },
      //获取配置信息
      getSetCofig(){
        this.http.getRequest({
          url:`app/exam/findRegisterInfo/${this.CONFIG_ITEM.id}`,
          msg:{},
          success:(res)=>{
            this.userShowList = res.data&&res.data.userShowList&&res.data.userShowList ? res.data.userShowList : []
            this.verifyUserInfo = res.data&&res.data.register&&res.data.register.verifyUserInfo ? res.data.register.verifyUserInfo : ''
            this.relevanceExam = res.data&&res.data.register&&res.data.register.relevanceExam ? res.data.register.relevanceExam : ''
            this.register = res.data&&res.data.register ? res.data&&res.data.register : {}
            //调用模板接口
            if(this.register.templateId){
              this.getFormData(this.register.templateId)
            }
            if(this.register.hasApplyRefund==1){
              this.getRefundInfo()
            }
          }
        })
      },
      indicate(i){
        return this.userShowList.some(item=>item===i)
      },
      //取消报名
      noCal(i){
        let bol = this.appHomeVO ? (Object.keys(this.appHomeVO)).length : 0
        if(bol<1){
          return
        }
        Dialog.confirm({
          title: '取消报名',
          message: '确定取消后，报名信息将全部删除，请谨慎操作。',
        }).then(() => {
          // on confirm
          if(i.payStatus==5){
            this.utils.toastNone('缴费处理中不允许取消报名！')
            return
          }
          if(i.status==2){
            this.utils.toastNone('报名已经结束！')
            return
          }
          this.http.postRequest({
            url:`app/exam/removeUserExamInfo/${this.appHomeVO.id}`,
            msg:{},
            success:(res)=>{
              this.utils.toastSuccess(res.msg)
              this.$router.replace('/myEnroll')
            }
          },true)
        }).catch(() => {
            // on cancel
        });
      },
      //获取动态表单
      getFormData(id){
        this.http.getRequest({
          url:'app/exam/getTemplateInfoById',
          msg:{id},
          success:(res)=>{
            let bol = res.data&&res.data.registerTemplatePickList&&res.data.registerTemplatePickList.length
            if(bol>0){
              let registerTemplatePickList = res.data.registerTemplatePickList
              registerTemplatePickList.forEach((item)=>{
                let obj = this.formDataArray.find((child)=>{
                  return (child.nameKey==item.name&&item.hasShow==1)
                })
                if(obj) {
                  obj.multiple = item.hasMultiple==1 ? true : false
                  if(obj.nameKey=='nation'){
                    obj.templateList = nationArr()
                  }else {
                    obj.templateList = (item.registerTemplateOptionList&& item.registerTemplateOptionList.length>0) ?  item.registerTemplateOptionList : []
                  }
                  obj.required =  item.hasRequired==1 ? true : false
                  if(obj.type=='text'||obj.type=='file'){
                    obj.showValue = this.userInfoExtPO[obj.nameKey] ? this.userInfoExtPO[obj.nameKey] : ''
                  }
                  if(obj.type=='date'){
                    obj.showValue = this.userInfoExtPO[obj.nameKey] ? this.dayjs(this.userInfoExtPO[obj.nameKey]).format('YYYY-MM-DD')  : ''
                  }
                  if(obj.type=='drop'){
                    let newArr = obj.templateList
                    let numArr =  this.userInfoExtPO[obj.nameKey] ? this.userInfoExtPO[obj.nameKey].split(',') : ''
                    if(numArr&&numArr.length>1){
                      let montageStr = ''
                      numArr.filter((t)=>{
                        let obs = newArr.find((i)=>{
                          return t == i.value
                        })
                        if(montageStr){
                          montageStr= montageStr + "," +obs.label
                        }else{
                          montageStr= montageStr + obs.label
                        }
                      })

                      obj.showValue = montageStr
                    }
                    if(numArr&&numArr.length==1){
                      let strObj =  newArr.find((sml)=>{
                        return  sml.value == numArr[0]
                      })
                      obj.showValue = strObj.label
                    }
                  }
                  this.fieldArray.push(obj)
                }
              })
            }
          }
        })
      },
      //动态表单信息
      getIdInfo(){
        this.http.getRequest({
          url:`app/exam/findRegisterInfoToModify/${this.CONFIG_ITEM.id}`,
          msg:{},
          success:(res)=>{
            this.getMore()
            if(res.data) {
              this.graduationTime = res.data.graduationTime ? res.data.graduationTime : ''
              this.hasNative = res.data.hasNative ? res.data.hasNative : ''
              this.theoryGrade = res.data.theoryGrade ? res.data.theoryGrade : ''
              this.userInfoExtPO = res.data.userInfoExtPO ? res.data.userInfoExtPO : {}
            }
          }
        })
      },
      //成绩公示
      goAchieve(i){
        if(this.register.publicType==1){
          this.$router.push({
            path: '/publicityGo',
            query:{
              id:i.id
            }
          })
        } else {
          if(this.register.hasReadGradeNotice==1){
            this.$router.push({
              path: '/notes',
              query:{
                historyId:i.id,
              }
            })
          }else {
            this.$router.push({
              path: '/publicity',
              query:{
                id:i.id
              }
            })
          }
//          this.$router.push({
//            path: '/publicity',
//            query:{
//              id:i.id
//            }
//          })
        }

      },
      getInfo () {
        this.http.postRequest({
          url: 'app/user/getUserInfo',
          msg: {},
          success: (res) => {
            this.SET_USER_KEY({key: 'userInfo', value: res.data ? res.data : ''})
          }
        })
      },
      goRefund(i,y){
        if(y!=1){
          return
        }
        if(i==1){
          this.$router.push({
            path:'/refundApply',
            query:{
              detailId:this.$route.query.detailId
            }
          })
        }
        if(i==2||i==3||i==4){
          this.$router.push({
            path:'/refundDetail',
            query:{
              detailId:this.$route.query.detailId
            }
          })
        }
      },
      //获取退款信息
      getRefundInfo(){
        this.http.getRequest({
          url: `app/exam/queryRefundInfo/${this.$route.query.detailId}`,
          msg: {},
          success: (res) => {
            this.examineStatus = res.data.examineStatus
//            console.log(res)
          }
        })
      }
    },
    mounted () {

    },
    filters: {
      numFilter:(value) =>{
        if (!value) return ''
        return value.replace(/(\w{6})\w*(\w{2})/, '$1******$2')
      },
//      strFilter:(val) =>{
//        let str = ''
//        if(val.type=='text'){
//          str = this.userInfoExtPO[val.nameKey]
//          return  str
//        }
//      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
.page{
  background: #F4F6F9;
  padding: 0 12px 90px 12px;

  .m-bg-cover{
    position: absolute;
    left: 0;
    right: 0;
    height: 180px;
    background: linear-gradient(360deg, #F4F6F9 0%, #2B6CF9 28% ,#2B6CF9 100%);
    z-index: -1;
  }
  .m-top-margin{
    margin-top: 30px;
  }
  .m-status{
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
  }
  .m-tit{
    margin-top: 8px;
    color: #ffffff;
    font-size: 14px;
  }
  .m-real{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 10px 12px;
    >span{
      font-weight: bold;
    }
  }
  .m-big-rel{
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    .m-black{
      padding: 8px 6px 8px 6px;
      background: #F9F9F9;
      border-radius: 2px;
      margin: 4px 8px 0 8px;
      >p{
        font-size: 13px;
        line-height: 18px;
        color: #1D232D;
      }
    }
    .m-kou{
      height: 8px;
    }
  }

  .m-info-box{
    background: #ffffff;
    border-radius: 4px;
    padding: 15px 12px 0 12px;
    margin-top: 18px;
    .m-info-tit{
      display: flex;
      align-items: center;
      padding-bottom: 15px;
      >img{
        width: 16px;
        height: 16px;
      }
      >span{
        color: #2B6CF9;
        font-weight: bold;
        margin-left: 3px;
      }
      .m-info-pay{
        flex: 1;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .m-app-btn{
          padding: 4px 4px;
          border-radius: 12px;
          border: 1Px solid #333333;
        }
        .m-right{
          color: #767A7F;
          font-size: 14px;
        }
      }
    }
    .m-bast{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 15px;
      >div{
        display: flex;
        align-items: center;
        >img{
          width: 16px;
          height: 16px;
        }
        >span{
          color: #2B6CF9;
          font-weight: bold;
          margin-left: 3px;
        }
      }
      .m-btn{
        height: 27px;
        line-height: 27px;
        color: #2B6CF9;
        border:1Px solid #2B6CF9;
      }
    }
    .m-nav{
      padding-bottom: 20px;
      display: flex;
      >span{
        display: inline-block;
        width: 90px;
        color: #8D8F93;
      }
      >p{
        flex: 1;
        text-align: right;
      }
      .m-pic{
        flex: 1;
        text-align: right;
        >img{
          width: 80px;
          height: 80px;
          object-fit: contain;
        }
      }
    }
  }
  .m-footer{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    z-index: 10;
    display: flex;
    align-items: center;
    height: 68px;
    justify-content: space-between;
    padding:  0 12px 0 25px;
    >span{
      color: #333333;
      font-weight: bold;
    }
    .m-left-footer{
      .m-btn{
        width: 99px;
      }
      .m-btn1{
        background: #F2F6FF;
        color: #2B6CF9;
        margin-right: 12px;
      }
    }
    .m-btn-box{
      display: flex;
      align-items: center;
      .m-btn{
        width: 99px;
      }
      .m-btn1{
        background: #F2F6FF;
        color: #2B6CF9;
        margin-right: 12px;
      }
      .m-btn2{
        margin-right: 0;
        background: #FFF5EA;
        color: #F19E3B;
      }
      .m-btn3{
        width: 110px;
        margin-right: 0;
        background: #F2F6FF;
        color: #2B6CF9;
      }
    }
  }
  .m-center{
    /*justify-content: center;*/
  }
  .m-cancel{
    text-align: center;
    color: #999999;
    margin-top: 20px;
  }
  .m-des{
    color: #F13C3A;
    line-height: 30px;
    .warning-o{
      font-size: 16px;
      margin-right: 5px;
    }
    >span{
      font-size: 13px;
    }
  }
}
.m-popup {
  width: 300px;
  height: 103px;
  background: #ffffff;
  font-size: 15px;
  overflow: hidden;
  .m-title {
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    height: 53px;
    line-height: 53px;
    border-bottom: 1Px solid #E7E7E7;
  }
  .m-chose {
    display: flex;
    > p {
      flex: 1;
      text-align: center;
      height: 50px;
      line-height: 50px;
      font-size: 15px;
      font-weight: bold;
    }
    > p:nth-child(2) {
      color: #2B6CF9;
      border-left: 1Px solid #E7E7E7;
    }
    a{
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}

.van-popup--center.van-popup--round {
  border-radius: 4px !important;
}
</style>

